// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__3hBjg","container":"Layout_container__aRAMu"};